import Loadable from "components/Loadable";
import { lazy } from "react";

const EmailLogList = Loadable(
  lazy(() => import("features/email/components/EmailLogList")),
);

const routes = {
  path: "email-logs",
  children: [
    {
      path: "",
      element: <EmailLogList />,
    },
  ],
};

export default routes;
